/* eslint-disable prettier/prettier */
// import { v4 as uuidV4 } from "uuid";

export const QUERY = {
  all: `
  query MyQuery {
    allMasterSpares(condition: {isActive: true}) {
      nodes {
        id
        value:id
        label:name
        name
        make
        model
        serialNo
      }
    }
  }
  
    `,
  add: ({ name, make, model, serialNo }) => `
  mutation MyMutation {
    createMasterSpare(
      input: {
        masterSpare: {
          name: "${name}"
          make: "${make}"
          model: "${model}"
          serialNo: "${serialNo}"
          isActive: true
          createdAt: "${new Date().toISOString()}"
          updatedAt: "${new Date().toISOString()}"
        }
      }
    ) {
      clientMutationId
    }
  }
    `,
  update: ({ id, isActive = true, name, make, model, serialNo }) => `
  mutation MyMutation {
    updateMasterSpareById(
      input: {
        masterSparePatch: {
          ${name ? `name: "${name}"` : ``}
          ${make ? `make: "${make}"` : ``}
          ${model ? `model: "${model}"` : ``}
          ${serialNo ? `serialNo: "${serialNo}"` : ``}
          isActive: ${isActive}
          updatedAt: "${new Date().toISOString()}"
        }
        id: ${id}
      }
    ) {
      clientMutationId
    }
  }`
};